import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChartCompareHorizontal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChartCompareHorizontal"><Path d="M3.5 3.5V20.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M5 14.5H18" stroke="currentColor"/><Path d="M5 9.5H12" stroke="currentColor"/><Path d="M5 17.5H10" stroke="currentColor"/><Path d="M5 6.5H16" stroke="currentColor"/></CentralIconBase>;
});

export default IconChartCompareHorizontal;
